import { render, staticRenderFns } from "./ServiceWorkerUpdatePopup.vue?vue&type=template&id=34c526ef&scoped=true&"
import script from "./ServiceWorkerUpdatePopup.vue?vue&type=script&lang=ts&"
export * from "./ServiceWorkerUpdatePopup.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceWorkerUpdatePopup.vue?vue&type=style&index=0&id=34c526ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c526ef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
